import { render, staticRenderFns } from "./ReadTransport.vue?vue&type=template&id=55293147&scoped=true"
import script from "./ReadTransport.vue?vue&type=script&lang=js"
export * from "./ReadTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55293147",
  null
  
)

export default component.exports